import * as yup from "yup";

export const bedStatusInitData = {
  availableOnWard: 0,
  availableOnICU: 0,
  occupiedOnWard: 0,
  occupiedOnICU: 0,
  totalWard: 0,
  totalIcu: 0,
  total: 0,
};

export const bedStatusValidationData = yup.object().shape({
  // total: yup.number().typeError('Must be a valid number').min(0, 'Must be a valid number').required("Required"),
  availableOnWard: yup.number().min(0).required("Required"),
  availableOnICU: yup.number().min(0).required("Required"),
  totalWard: yup.number().min(0).required("Required"),
  occupiedOnWard: yup.number().min(0).required("Required"),
  occupiedOnICU: yup.number().min(0).required("Required"),
  totalIcu: yup.number().min(0).required("Required"),
});
